import { render, staticRenderFns } from "./PDFPrint.vue?vue&type=template&id=b2e2fc44"
import script from "./PDFPrint.vue?vue&type=script&lang=ts"
export * from "./PDFPrint.vue?vue&type=script&lang=ts"
import style0 from "./PDFPrint.vue?vue&type=style&index=0&id=b2e2fc44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports